import { render, staticRenderFns } from "./b2b-list-item.vue?vue&type=template&id=adf8818c&functional=true"
import script from "./b2b-list-item.vue?vue&type=script&lang=js"
export * from "./b2b-list-item.vue?vue&type=script&lang=js"
import style0 from "./b2b-list-item.vue?vue&type=style&index=0&id=adf8818c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports